module.exports = __webpack_public_path__ + "static/media/univilltrade.c834adbe.png";